import { Box, Button, Flex, Menu, Text, rem } from "@mantine/core";
import { modals } from "@mantine/modals";
import {
  IconArrowsLeftRight,
  IconChevronDown,
  IconDotsVertical,
  IconEdit,
  IconFileDownload,
  IconFileExport,
  IconMessageCircle,
  IconPhoto,
  IconPlus,
  IconRefresh,
  IconSearch,
  IconSend2,
  IconSettings,
  IconTrash,
  IconUsers,
} from "@tabler/icons-react";
// import { updateSearchItemProduct } from "../../api/ApiProduct";
import { IconFilePlus } from "@tabler/icons-react";
import { useLocation } from "react-router-dom";

const AppAction = ({
  openModal,
  openModalEdit,
  openModalDelete,
  openModalAssign,
  openModalPos,
  openExportExcel,
  isUpdateSearchItem,
  isShowOtherAction = false,
  openModalupdateExel,
  exportExcel,
  openModalCreate,
}: AppActionProps) => {
  const location = useLocation();
  console.log("location", location.pathname);

  const handleOpenConfirmExport = () => {
    modals.openConfirmModal({
      title: "Xác nhận xuất Excel",
      top: "true",
      children: (
        <Text top={"10"} size="md">
          Bạn có chắc chắn muốn xuất dữ liệu ra file Excel không?
        </Text>
      ),
      labels: { confirm: "Xác nhận", cancel: "Hủy" },
      confirmProps: { color: "green" },
      onConfirm: () => {
        if (openExportExcel) {
          openExportExcel();
        }
      },
    });
  };

  return (
    <Box style={{ overflow: "hidden" }}>
      <Flex
        direction={"row"}
        wrap={"wrap"}
        justify="space-between"
        align="center"
        mt={10}
      >
        <Flex direction={"row"} gap="sm" mb={10}>
          {/* {location.pathname === "/product-list" ? (
            <>
              <Button
                color="blue"
                variant="outline"
                leftSection={<IconFileDownload size={14} />}
                onClick={() => doaloadFileExcel()}
              >
                Tải file Import mẫu
              </Button>
            </>
          ) : null} */}
        </Flex>
        <Flex direction={"row"} gap="sm" mb={10}>
          {(openModalCreate || openModal) && (
            <Button
              onClick={openModalCreate || openModal}
              leftSection={<IconPlus size={14} />}
              color="blue"
              variant="outline"
            >
              Thêm mới
            </Button>
          )}
          {openModalAssign && (
            <Button
              onClick={openModalAssign}
              leftSection={<IconUsers size={14} />}
              color="green"
              variant="outline"
            >
              Chọn người phụ trách
            </Button>
          )}
          {openModalEdit && (
            <Button
              leftSection={<IconEdit size={14} />}
              onClick={openModalEdit}
              color="orange"
              variant="outline"
            >
              Chỉnh sửa
            </Button>
          )}
          {openModalDelete && (
            <Button
              leftSection={<IconTrash size={14} />}
              onClick={openModalDelete}
              color="red"
              variant="outline"
            >
              Xóa (Đã chọn)
            </Button>
          )}

          {/* {isUpdateSearchItem && (
            <Button
              onClick={() => updateSearchItemProduct()}
              leftSection={<IconRefresh size={14} />}
              color="green"
              variant="outline"
            >
              Cập nhật đồng bộ
            </Button>
          )} */}

          {openModalPos && (
            <Button
              onClick={openModalPos}
              leftSection={<IconSend2 size={14} />}
              color="blue"
              variant="outline"
            >
              Gửi đơn sang POS
            </Button>
          )}
          {/* {location.pathname === "/product-manager/product-list" &&
            exportExcel && ( //chỉ hiển thị export ở màn danh sách đơn
              <Button
                leftSection={<IconFileDownload size={14}></IconFileDownload>}
                onClick={exportExcel}
                color="yellow"
                variant="outline"
              >
                Export Excel
              </Button>
            )} */}

          {openExportExcel && (
            <Button
              // onClick={openExportExcel}
              onClick={handleOpenConfirmExport}
              leftSection={<IconFileExport size={14} />}
              color="green"
              variant="outline"
            >
              Export Excel
            </Button>
          )}
          {openModalupdateExel && (
            <Button
              onClick={openModalupdateExel}
              leftSection={<IconFilePlus size={14} />}
              color="indigo"
              variant="outline"
            >
              Import Excel
            </Button>
          )}

          {isShowOtherAction && (
            <Menu shadow="md" trigger="hover" openDelay={100} closeDelay={200}>
              <Menu.Target>
                <Button
                  rightSection={<IconChevronDown size={14} />}
                  leftSection={<IconDotsVertical size={14} />}
                  color="violet"
                  variant="outline"
                >
                  Thao tác khác
                </Button>
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Label>Application</Menu.Label>
                <Menu.Item
                  leftSection={
                    <IconSettings style={{ width: rem(14), height: rem(14) }} />
                  }
                >
                  Settings
                </Menu.Item>
                <Menu.Item
                  leftSection={
                    <IconMessageCircle
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                >
                  Messages
                </Menu.Item>
                <Menu.Item
                  leftSection={
                    <IconPhoto style={{ width: rem(14), height: rem(14) }} />
                  }
                >
                  Gallery
                </Menu.Item>
                <Menu.Item
                  leftSection={
                    <IconSearch style={{ width: rem(14), height: rem(14) }} />
                  }
                  rightSection={
                    <Text size="xs" c="dimmed">
                      ⌘K
                    </Text>
                  }
                >
                  Search
                </Menu.Item>

                <Menu.Divider />

                <Menu.Label>Danger zone</Menu.Label>
                <Menu.Item
                  leftSection={
                    <IconArrowsLeftRight
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                >
                  Transfer my data
                </Menu.Item>
                <Menu.Item
                  color="red"
                  leftSection={
                    <IconTrash style={{ width: rem(14), height: rem(14) }} />
                  }
                >
                  Delete my account
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          )}
        </Flex>
      </Flex>
    </Box>
  );
};

export default AppAction;

type AppActionProps = {
  openModal?: () => void;
  openModalEdit?: () => void;
  openModalDelete?: () => void;
  openModalAssign?: () => void;
  openModalPos?: () => void;
  openExportExcel?: () => void;
  isShowOtherAction?: boolean;
  isUpdateSearchItem?: boolean;
  openModalupdateExel?: () => void;
  exportExcel?: () => void;
  openModalCreate?: () => void;
};
